import { derived } from "svelte/store";
import { countryStore, defaultCountry } from "../stores/country";
import { languageStore, type Language } from "../stores/language";
import { type SupportedCountryCode, campaignCountries } from "./countries";
import SUPPORTED_LANGUAGES, { defaultLanguage } from "./languages";

const templates: Record<Language, string> = {
  en: "Qualifying purchase defined as",
  es: "Compra válida definida como",
  fr: "L'achat admissible est défini comme étant de"
};

const generateSameAmounts = (amount: string) => ({
  en: amount,
  es: amount,
  fr: amount,
});

const amounts: Record<SupportedCountryCode, Record<Language, string>> = {
  US: generateSameAmounts("$3 USD"),
  MX: generateSameAmounts("$50 MXN"),
  CA: { // I guess french only really matters for Canada
    en: "$4.99 CAD", // English Canadian - period for decimal
    es: "$4.99 CAD", // Spanish uses same as English
    fr: "4,99 $ CA" // French Canadian - comma for decimal, $ after
  },
  CL: generateSameAmounts("$10.000 CLP"), // Chile uses periods as thousands separator, commas as decimal separator
  GT: generateSameAmounts("Q 50.00"),
  NI: generateSameAmounts("C $240 NIO"),
  SV: generateSameAmounts("$6.00 USD"),
  DO: generateSameAmounts("RD $550 DOP"),
  HN: generateSameAmounts("L 274 HNL"),
};

const supportedLanguages = [...SUPPORTED_LANGUAGES.map(language => language.key)];

export const qualifyingPurchase = derived([countryStore, languageStore], ([$country, $language]) => {
  const country = campaignCountries.includes($country) ? $country : defaultCountry;
  const language = supportedLanguages.includes($language) ? $language : defaultLanguage;

  return `${templates[language]} ${amounts[country][language]}.`;
});
